"use client"

import { Cabecera } from "@/components/landing/zindra/cabecera"

/**
 * La cabecera de las páginas públicas de antes (directorio, glosario,
 * plantillas, calculadoras…). Es la misma de la web nueva, fija arriba como
 * era esta, para que esas páginas —que dejan hueco para ella— no se muevan.
 */
export default function PublicHeader(_props: { isHome?: boolean }) {
  return <Cabecera fija />
}
